var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 756,
    height: 389,
    viewBox: "0 0 756 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_641)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_249_641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 748.17C581.241 748.17 746 583.411 746 380.17C746 176.929 581.241 12.17 378 12.17C174.759 12.17 10 176.929 10 380.17C10 583.411 174.759 748.17 378 748.17Z",
    fill: "#2E3033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 747.67C580.965 747.67 745.5 583.135 745.5 380.17C745.5 177.205 580.965 12.67 378 12.67C175.035 12.67 10.5 177.205 10.5 380.17C10.5 583.135 175.035 747.67 378 747.67Z",
    stroke: "#D8BE8D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_249_641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378 660.17C532.64 660.17 658 534.81 658 380.17C658 225.53 532.64 100.17 378 100.17C223.36 100.17 98 225.53 98 380.17C98 534.81 223.36 660.17 378 660.17Z",
    fill: "#2E3033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 659.67C532.364 659.67 657.5 534.534 657.5 380.17C657.5 225.806 532.364 100.67 378 100.67C223.636 100.67 98.5 225.806 98.5 380.17C98.5 534.534 223.636 659.67 378 659.67Z",
    stroke: "#D8BE8D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_249_641",
    x: 0,
    y: 0.170044,
    width: 756,
    height: 756,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_249_641",
    x: 88,
    y: 88.17,
    width: 580,
    height: 580,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_641"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_641",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 756,
    height: 389,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockBig);
export default __webpack_public_path__ + "static/media/blockBig.b87daece796b1b51ce748ec9075741a5.svg";
export { ForwardRef as ReactComponent };